import SwmsManagement from './SwmsManagement'
export default SwmsManagement
